<template>
  <div class="header" :class="classList">
    <div class="header__special">
      <div class="header__special-label">Специальный проект</div>
    </div>
    <div class="header__logotypes">
      <a href="https://jet.su/" @click="$metrics.pushEvent($metrics.events.CLICK_LOGO_JET_HEADER)" title="Компания «Инфосистемы Джет»" class="header__logo header__logo--jet">
        <img src="@/assets/images/logo-jet.svg" class="header__logo-img">
      </a>
      <a href="https://huawei.ru/" @click="$metrics.pushEvent($metrics.events.CLICK_LOGO_HUAWEI_HEADER)" title="Huawei" class="header__logo header__logo--huawei">
        <img src="@/assets/images/logo-huawei.svg" class="header__logo-img">
      </a>
      <div class="header__logotypes-divider"></div>
      <a href="https://vedomosti.ru" target="_blank" title="Ведомости" class="header__logo header__logo--ved-sm header__logo--mobile">
        <img src="@/assets/images/logo-ved-sm.svg" class="header__logo-img">
      </a>

      <a href="https://vedomosti.ru" target="_blank" title="Ведомости" class="header__logo header__logo--ved-md header__logo--desktop">
        <img src="@/assets/images/logo-ved-md.svg" class="header__logo-img">
      </a>

    </div>
  </div>
</template>

<script>
  export default {
    props: {
      size: {
        validator: prop => ['sm', 'md'].indexOf(prop) > -1,
        default: 'md'
      }
    },
    computed: {
      classList () {
        return {
          [`header--${this.size}`]: true
        }
      }
    }
  }
</script>

<style lang="scss">
  .header {
    position: relative;
    display: flex;
    align-items: center;
  }

  .header__special {
    @include more(scale) {
      position: absolute;
      right: calc(100% + 10rem);
      top: 0;
      letter-spacing: 0.05em;
      font-size: 3.5rem;
      line-height: 4rem;
      transform-origin: 100% 0%;
      transform: rotate(-90deg);
      white-space: nowrap;
    }
    @include less(tablet) {
      right: calc(100% + 60px);
      order: 5;
      font-size: 14px;
      width: 95px;
      height: 30px;
      margin-right: 0;
      margin-left: auto;
      & > * {
        display: block;
        margin-left: auto;
        margin-right: 0;
      }
    }
    @include mq(xmobile) {
      display: none;
    }
  }

  .header__logotypes {
    display: flex;
    align-items: center;
    & > * {
      @include more(scale) {
        .header--md & {
          margin-right: 8rem;
        }
        .header--sm & {
          margin-right: 6rem;
        }
      }
      @include less(tablet) {
        margin-right: 25px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .header__logotypes-divider {
    border-left: 1px solid #fff;

    @include more(scale) {
      .header--md & {
        height: 20rem;
        border-left-width: 2px;
      }
      .header--sm & {
        height: 15rem;
      }
    }
    @include less(tablet) {
      height: 40px;
    }
  }

  .header__logo {
    outline: none;
  }

  .header__logo-img {
    display: block;
  }

  .header__logo--desktop {
    @include less(tablet) {
      display: none !important;
    }
  }

  .header__logo--mobile {
    @include more(scale) {
      display: none !important;
    }
  }

  .header__logo--jet .header__logo-img {
    @include more(scale) {
      .header--md & {
        height: 20rem;
      }
      .header--sm & {
        height: 12.5rem;
      }
    }
    @include less(tablet) {
      height: 40px;
    }
  }

  .header__logo--huawei .header__logo-img {
    @include more(scale) {
      .header--md & {
        height: 20rem;
      }
      .header--sm & {
        height: 12.5rem;
      }
    }
    @include less(tablet) {
      height: 40px;
    }
  }

  .header__logo--ved-md .header__logo-img {
    @include more(scale) {
      .header--md & {
        height: 8rem;
      }
      .header--sm & {
        height: 6rem;
      }
    }
  }

  .header__logo--ved-sm .header__logo-img {
    @include less(tablet) {
      height: 30px;
    }
  }
</style>
